import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import GHLConnectionStatus from '../components/GHLConnectionStatus';

function Dashboard() {
  const [raffles, setRaffles] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, logout } = useAuth();

  useEffect(() => {
    loadRaffles();
  }, []);

  const loadRaffles = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/raffles`);
      setRaffles(response.data.data);
    } catch (error) {
      console.error('Error loading raffles:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>My Raffles</h1>
        <div>
          <span style={{ marginRight: '20px' }}>Welcome, {user?.name}</span>
          {user?.is_admin && (
            <Link to="/admin">
              <button style={{ marginRight: '10px', background: '#6c757d' }}>Admin Panel</button>
            </Link>
          )}
          <Link to="/raffles/create">
            <button>Create Raffle</button>
          </Link>
          <button onClick={logout} style={{ marginLeft: '10px', background: '#dc3545' }}>
            Logout
          </button>
        </div>
      </div>

      <GHLConnectionStatus />

      {loading ? (
        <div>Loading...</div>
      ) : raffles.length === 0 ? (
        <div className="card">
          <p>No raffles yet. Create your first raffle to get started!</p>
        </div>
      ) : (
        <div>
          {raffles.map(raffle => (
            <div key={raffle.id} className="card">
              <h3>{raffle.title}</h3>
              <p>{raffle.description}</p>
              <div style={{ marginTop: '10px' }}>
                <span style={{ marginRight: '20px' }}>
                  <strong>Status:</strong> {raffle.status}
                </span>
                <span style={{ marginRight: '20px' }}>
                  <strong>Entries:</strong> {raffle.total_entries}
                </span>
                <span>
                  <strong>Price:</strong> ${raffle.entry_price}
                </span>
              </div>
              <div style={{ marginTop: '10px' }}>
                <Link to={`/raffles/${raffle.id}`}>
                  <button>View Details</button>
                </Link>
                <Link to={`/raffle/${raffle.id}`} target="_blank" style={{ marginLeft: '10px' }}>
                  <button style={{ background: '#28a745' }}>Public Page</button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Dashboard;
